import React, { Component } from 'react'
import ReactPlayer from 'react-player';
export default class DetailsVideo extends Component {
    render() {
        const {videos} = this.props.details;
       
        return (
            <div className="trailer">
               <p className="trailer-title">Trailers and Teasers</p> 
               <div className="videos">
               {videos!=undefined&&videos.map((video,key)=>{
                   if(key>=3){
                       return;
                   }else
                return  <ReactPlayer url={`https://www.youtube.com/watch?v=${video.key}`} className="player" key={key} controls={true} height="210px" width="384px" />
               })}
                  
               
               </div>
            </div>
        )
    }
}
